export default "__VITE_ASSET__0fc97644__"